module.exports = __webpack_public_path__ + "static/img/bg3.5f5f133f.png";